// extracted by mini-css-extract-plugin
module.exports = {"container":"ManageAppoint_container__2lh3H","header":"ManageAppoint_header__3JXqJ","body":"ManageAppoint_body__3ZaYy","box":"ManageAppoint_box__1xboh"};